import { IShift, ShiftService } from '../services/shifts.service';
import { EmployeesService, AccountsService, ITeam } from "../services/index";
import * as moment from "moment";

class ChatPanelController {
    private shifts: IShift[];
    private currentShift: IShift;
    private locations: any;
    private teams: ITeam[];
    private accountNotes: any;
    private employees: any;
    private selectedEmployee: any;

    constructor(private $state: ng.ui.IStateService,
                private $scope: ng.IScope,
                private ShiftService: ShiftService,
                private EmployeesService: EmployeesService,
                private AccountsService: AccountsService) {
        'ngInject';       
    }

    $onInit = () => {
        // this.$scope.$on('getAdHocShiftsDown', (event, data) => { 
        //     console.log('getAdHocShiftsDown'); 
        // });      
    }

    isSameDay(start, end) {
        if (moment(start).toDate().getDate() == moment(end).toDate().getDate()) {
            return true;
        } else {
            return false;
        }
    }

    openShift(item) {
        this.currentShift = item;

        this.setLocations();
        this.setAccountNotes();
        this.setEmployees();        

        (<any>$('#check-availability-modal')).modal('show');
    }

    setLocations() {
        if (this.currentShift.teamLocationAccountId) {
            this.AccountsService.getChild(this.currentShift.teamLocationAccountId, 'locations').then((result) => {
                this.locations = result;
                this.setTeams();
            });
        }
    }

    setAccountNotes() {
        if (this.currentShift.teamLocationAccountId) {
            this.AccountsService.getChild(this.currentShift.teamLocationAccountId, 'notes/?tag=planning').then((result) => {
                this.accountNotes = result;
            });
        }
    }

    setEmployees() {
        if (this.currentShift.start && this.currentShift.end) {
            var request = {
                accountId: this.currentShift.teamLocationAccountId,
                locationId: this.currentShift.teamLocationId,
                startDate: this.currentShift.start,
                endDate: this.currentShift.end,
                shiftId: this.currentShift.id
            };

            this.EmployeesService.customPost('availableEmployees', request, false).then((result) => {
                this.employees = result;

                this.selectedEmployee = this.employees.find(employeeSummary => employeeSummary.employee.id == this.currentShift.employeeId);
            });
        }
    }

    setTeams() {
        if (this.currentShift.teamLocationId) {
            this.teams = this.locations.find(item => item.id === this.currentShift.teamLocationId).teams;
        }
    }

    approve(event, shift) {
        event.stopPropagation();
        shift.status = 6;
        this.updateShift(shift);
    }

    reject(event, shift) {
        event.stopPropagation();
        shift.status = 99;
        this.updateShift(shift);
    }

    updateShift(shift) {
        this.ShiftService.put(shift.id, shift).then((data) => {
            this.shifts = this.shifts.filter(s => s.id !== shift.id);
        });
    }
}

export const chatPanelComponent = {
    bindings: {
        shifts: '=',
        currentShift: '=',
        locations: '=',
        teams: '=',
        accountNotes: '=',
        employees: '=',
        selectedEmployee: '='
    },
    controller: ChatPanelController,
    template: require('./chatPanel.html')
};



// WEBPACK FOOTER //
// ./src/app/main/chatPanel.component.ts